module.exports = __webpack_public_path__ + "static/media/grey.b0994705.jpg";